import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
// import { Workbook } from 'exceljs';

import * as ExcelJS from 'exceljs/dist/exceljs.min.js';
import { AppSettingService } from './app-setting.service';
declare const ExcelJS: ExcelJS;

@Injectable({
  providedIn: 'root'
})
export class ExcelFileService {
  headersArrayLocal = [];
  footerArrayLocal = [];
  headerWeekArray = [];
  HeaderRowsCount = 2;

  constructor(public datePipe: DatePipe, public appSettingService: AppSettingService) { }

  fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  fileExtension = '.xlsx';


  generateWeeklyTotalsCell1(worksheet: ExcelJS.Worksheet, columnLetter: string, totalDataRows: number) {
    const firstDataRow = this.HeaderRowsCount + 1;
    const lastDataRow = firstDataRow + totalDataRows - 1;
    const firstCellReference = `${columnLetter}${firstDataRow}`;
    const lastCellReference = `${columnLetter}${lastDataRow}`;
    const sumRange = `${firstCellReference}:${lastCellReference}`;
    return {
      formula: `SUM(${sumRange})`, result: (worksheet.getCell('B3').value + worksheet.getCell('D3').value)
    };
  }

  generateWeeklyTotalsCell(worksheet: ExcelJS.Worksheet, columnLetter: string, totalDataRows: number) {
    const firstDataRow = this.HeaderRowsCount + 1;
    const lastDataRow = firstDataRow + totalDataRows - 1;
    const firstCellReference = `${columnLetter}${firstDataRow}`;
    const lastCellReference = `${columnLetter}${lastDataRow}`;
    const sumRange = `${firstCellReference}:${lastCellReference}`;
    let grantTotal = 0;
    for (let rowNo = firstDataRow; rowNo <= totalDataRows; rowNo++) {
      grantTotal = grantTotal + worksheet.getCell(columnLetter + '' + rowNo).value;
    }
    console.log('total..>> ' + grantTotal + 'columnLetter---->>' + columnLetter);
    return {
      formula: `SUM(${sumRange})`, result: (grantTotal)
    };
  }



  getColumnName(worksheet: ExcelJS.Worksheet, columnNo: number) {
    console.log(worksheet.getColumn(columnNo).letter);
    return worksheet.getColumn(columnNo).letter;
  }

  public async exportFullfillmentExcel(json: any[], excelFileName: string, headersArray: any[]
    // tslint:disable-next-line:align
    , partner: string , month: Date): Promise<void> {
this.headerWeekArray = [];
this.footerArrayLocal = [];
this.headerWeekArray = [];

if(partner === '') {
partner = 'All_Customer';

}
// Excel Title, Header, Data
const header = headersArray;
const data = json;
// Create workbook and worksheet
let workbook = new ExcelJS.Workbook();
const worksheet = workbook.addWorksheet(excelFileName);
let num = 0;

// worksheet.mergeCells('A1:A2');
headersArray.forEach((element) => {
if (num === 0) {
this.headerWeekArray.push('Location ( ' + partner + ' )');
}
this.headerWeekArray.push('Week ' + (num + 1) + ' ( '
+ this.datePipe.transform(element.start, this.appSettingService.globelDateFormat) + ' - '
+ this.datePipe.transform(element.end, this.appSettingService.globelDateFormat) + ' )');
this.headerWeekArray.push('');
this.headerWeekArray.push('');
this.headerWeekArray.push('');
this.headerWeekArray.push('');
this.headerWeekArray.push('');
num++;
});
this.headerWeekArray.push('Total Months (' + this.datePipe.transform(month, 'MMM') + '/'
+ this.datePipe.transform(month, 'y') + ')'  );
this.headerWeekArray.push('');
this.headerWeekArray.push('');
this.headerWeekArray.push('');
this.headerWeekArray.push('');
this.headerWeekArray.push('');
const weekRow = worksheet.addRow(this.headerWeekArray);


for (let rowNo = 0; rowNo <= headersArray.length; rowNo++) {

switch (rowNo) {
case 0: {
worksheet.mergeCells('B1:G1');
break;
}
case 1: {
worksheet.mergeCells('H1:M1');
break;
}
case 2: {
worksheet.mergeCells('N1:S1');
break;
}
case 3: {
worksheet.mergeCells('T1:Y1');
break;
}
case 4: {
worksheet.mergeCells('Z1:AE1');
break;
}
case 5: {
worksheet.mergeCells('AF1:AK1');
break;
}
case 6: {
worksheet.mergeCells('AL1:AQ1');
break;
}
}
num++;
}

weekRow.eachCell((cell) => {
cell.fill = {
type: 'pattern',
pattern: 'solid',
fgColor: { argb: '8EA9DB' },
bgColor: { argb: '8EA9DB' }
};
cell.font = { bold: true, color: { argb: 'FF0000' }, };
cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
cell.alignment = {
vertical: 'middle',
horizontal: 'center'
}
});

// footerRow.getCell(1).fill = {
//   type: 'pattern',
//   pattern: 'solid',
//   fgColor: { argb: 'FFCCFFE5' }
// };

weekRow.getCell(1).fill = {
type: 'pattern',
pattern: 'solid',
fgColor: { argb: '8EA9DB' },
bgColor: { argb: '8EA9DB' },
};
weekRow.getCell(1).font = { bold: true, color: { argb: 'FFFFFF' }, };
weekRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
weekRow.getCell(1).alignment = {
vertical: 'middle',
horizontal: 'center'
};

this.headersArrayLocal = [];
this.footerArrayLocal = [];
num = 0;
headersArray.forEach((element) => {
if (num === 0) {
this.headersArrayLocal.push('');
}
this.headersArrayLocal.push('No. of Orders');
this.headersArrayLocal.push('Complete Orders');
this.headersArrayLocal.push('BoL Not Received');
this.headersArrayLocal.push('Partial Orders');
this.headersArrayLocal.push('SKU Quantity');
this.headersArrayLocal.push('SKU Quantity not received');
num++;
});
this.headersArrayLocal.push('No. of Orders');
this.headersArrayLocal.push('Complete Orders');
this.headersArrayLocal.push('BoL Not Received');
this.headersArrayLocal.push('Partial Orders');
this.headersArrayLocal.push('SKU Quantity');
this.headersArrayLocal.push('SKU Quantity not received');
const headerColumn = worksheet.addRow(this.headersArrayLocal);


headerColumn.eachCell((cell) => {
cell.fill = {
type: 'pattern',
pattern: 'solid',
fgColor: { argb: '8EA9DB' },
bgColor: { argb: '8EA9DB' },
};
cell.font = { bold: true, color: { argb: 'FFFFFF' }, };
cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
cell.alignment = {
vertical: 'middle',
horizontal: 'center'
}
});

// this.headersArrayLocal = [];
// this.headersArrayLocal.push('=SUM(AQ3:AQ84)');
// worksheet.addRow(this.headersArrayLocal);



worksheet.mergeCells('A1:A2');

let grantTotal = 0;

await  data.forEach((date1) => {
const eachRow = [];
let countOfTotal = 0;
let repCompleteOrdersToatl = 0;
let repBolNotReceivedTotal = 0;
let repPartialOrdersTotal = 0;
let repSkuQuantityTotal = 0;
let repSkuQuantityNotReceivedTotal = 0;
// tslint:disable-next-line:prefer-const
let datacount = 0;
for (const element of date1.value) {
const eachRow1 = [];
if (datacount === 0) {
eachRow.push(element.customerLocationName);
}
countOfTotal = countOfTotal + element.rep_Count_of_PO;
grantTotal = grantTotal + element.rep_Count_of_PO;
repCompleteOrdersToatl = repCompleteOrdersToatl + element.rep_Complete_Orders;
repBolNotReceivedTotal = repBolNotReceivedTotal + element.rep_Bol_Not_Received;
repPartialOrdersTotal = repPartialOrdersTotal + element.rep_partial_Orders;
repSkuQuantityTotal = repSkuQuantityTotal + element.rep_Sku_Quantity;
repSkuQuantityNotReceivedTotal = repSkuQuantityNotReceivedTotal + element.rep_Sku_Quantity_not_received;
eachRow.push(element.rep_Count_of_PO);
eachRow.push(element.rep_Complete_Orders);
eachRow.push(element.rep_Bol_Not_Received);
eachRow.push(element.rep_partial_Orders);
eachRow.push(element.rep_Sku_Quantity);
eachRow.push(element.rep_Sku_Quantity_not_received);
datacount++;
}
eachRow.push(countOfTotal);
eachRow.push(repCompleteOrdersToatl);
eachRow.push(repBolNotReceivedTotal);
eachRow.push(repPartialOrdersTotal);
eachRow.push(repSkuQuantityTotal);
eachRow.push(repSkuQuantityNotReceivedTotal);
let dataWorkSheet =  worksheet.addRow(eachRow);
//worksheet.row.commit();
});

// tslint:disable-next-line:only-arrow-functions
worksheet.eachRow(function(row, rowNumber) {
row.commit();
});


worksheet.getColumn(1).width = 35;

let numWidth = 1;
this.headersArrayLocal.forEach((element) => {
if (numWidth !== 1) {
worksheet.getColumn(numWidth).width = 25;
}
numWidth++;
});

// Footer Row
num = 1;
this.footerArrayLocal = [];
this.headersArrayLocal.forEach((element) => {
if (num === 1) {
this.footerArrayLocal.push('Total');
}
num++;
if (num <= this.headersArrayLocal.length) {
this.footerArrayLocal.push(this.generateWeeklyTotalsCell(worksheet, this.getColumnName(worksheet, num), data.length));
}
});

// tslint:disable-next-line:prefer-const
const footerRow = worksheet.addRow(this.footerArrayLocal);
// const footerRow = worksheet.addRow(['Total',
// this.generateWeeklyTotalsCell(worksheet, 'B', data.length),this.generateWeeklyTotalsCell(worksheet, 'C', data.length)]);



// footerRow.getCell(1).fill = {
//   type: 'pattern',
//   pattern: 'solid',
//   fgColor: { argb: 'FFCCFFE5' }
// };
// footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };

footerRow.eachCell((cell) => {
cell.fill = {
type: 'pattern',
pattern: 'solid',
fgColor: { argb: 'D9E1F2' }
};
cell.font = { bold: true };
cell.border = {
top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' }
};
});

// footerRow.getCell(2).value = {formula : 'SUM(B3,B4)', result: (worksheet.getCell('B3').value + worksheet.getCell('B4').value)  };

await  workbook.xlsx.writeBuffer().then((data: any) => {
const blob = new Blob([data], { type: this.fileType });
FileSaver.saveAs(blob, 'M2M-Fulfillment-Report-' + partner + '_' + this.datePipe.transform(month, 'MMM') + '_'
+ this.datePipe.transform(month, 'y') + ''+ this.fileExtension);
});

}



  public exportFullfillmentExcel1(json: any[], excelFileName: string, headersArray: any[]): void {
    // Excel Title, Header, Data
    const header = headersArray;
    const data = json;
    // Create workbook and worksheet
    let workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(excelFileName);
    // Add Header Row
    const headerRow = worksheet.addRow(header);
    // Cell Style : Fill and Border
    headerRow.eachCell((cell) => {
      cell.fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FFFFFF00' },
        bgColor: { argb: 'FF0000FF' }
      };
      cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } };
    });
    // Add Data and Conditional Formatting
    data.forEach((element) => {
      const eachRow = [];
      headersArray.forEach((headers) => {
        eachRow.push(element[headers]);
      });
      if (element.isDeleted === 'Y') {
        const deletedRow = worksheet.addRow(eachRow);
        deletedRow.eachCell((cell) => {
          cell.font = { name: 'Calibri', family: 4, size: 11, bold: false, strike: true };
        });
      } else {
        worksheet.addRow(eachRow);
      }
    });
    worksheet.getColumn(3).width = 15;
    worksheet.getColumn(4).width = 20;
    worksheet.getColumn(5).width = 30;
    worksheet.getColumn(6).width = 30;
    worksheet.getColumn(7).width = 10;
    worksheet.addRow([]);
    // Generate Excel File with given name
    // tslint:disable-next-line:no-shadowed-variable
    workbook.xlsx.writeBuffer().then((data: any) => {
      const blob = new Blob([data], { type: this.fileType });
      FileSaver.saveAs(blob, excelFileName + '_export_' + new Date().getTime() + this.fileExtension);
    });

  }


  // public exportPbjReortWothPoReportExcel(jsonData: any[], poJsonData: any[], fileName: string): void {

  //   let headersArray =['Date', 'PO', 'BoL', 'Invoice', 'P2B', 'B2I', 'Sum of Shipped Qty 0'];


  //   let workbook = new ExcelJS.Workbook();

  //   const data = jsonData;

  //   const worksheet = workbook.addWorksheet('PB&J Dashboard');
  //   // worksheet.getColumn(3).numFmt = '0';
  //   worksheet.getCell('F7').alignment = { horizontal:'right'} ;


  //   data.forEach((element) => {
  //     const eachRow = [];
  //     headersArray.forEach((headers) => {
  //       eachRow.push(element[headers]);
  //     });
  //     worksheet.addRow(eachRow);
  //   });

  //   workbook.xlsx.writeBuffer().then((data: any) => {
  //     const blob = new Blob([data], { type: this.fileType });
  //     FileSaver.saveAs(blob, fileName + '_export_' + new Date().getTime() + this.fileExtension);
  //   });

  //   // const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
   
  //   // const poWs: XLSX.WorkSheet = XLSX.utils.json_to_sheet(poJsonData);
  //   // const wb: XLSX.WorkBook = { Sheets: { 'PB&J Dashboard': ws, 'Purchase Order Report': poWs },
  //   // SheetNames: ['PB&J Dashboard', 'Purchase Order Report'], };
  //   // const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  //   // this.saveExcelFile(excelBuffer, fileName);
  // }

  public exportPbjReortWothPoReportExcel(jsonData: any[], poJsonData: any[], fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const poWs: XLSX.WorkSheet = XLSX.utils.json_to_sheet(poJsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'PB&J Dashboard': ws, 'Purchase Order Report': poWs },
    SheetNames: ['PB&J Dashboard', 'Purchase Order Report'], };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }




  public exportMonthlyLocationReportExcel(jsonData: any[], fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }

  public exportUnprocessedExcel(jsonData: any[], fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }

  public exportMonthlyExceptionReportM2mExcel(jsonData: any[], fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }

  public exportMonthlyExceptionReportCCExcel(jsonData: any[], fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }

  public exportEdiEdparTableExcel(jsonData: any[], fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }

  public exportCustomerMaterialTableExcel(jsonData: any[], fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }
  public exportPurchaseOrderReportTableExcel(jsonData: any[], fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }
  public exportBOLReportTableExcel(jsonData: any[], fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }
  public exportPOLjneItemDetailReportTableExcel(jsonData: any[], fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }
  public exportDunsIdTableExcel(jsonData: any[], fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }

  exportPartnerStoreExcel(jsonData: any[], fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }
public exportMonthlyExceptionsReportsExcel(jsonData: any[], fileName: string): void {
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
    const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    this.saveExcelFile(excelBuffer, fileName);
  }

  private saveExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], { type: this.fileType });
    FileSaver.saveAs(data, fileName + this.fileExtension);
  }


  // public exportFullfillmentExcel(jsonData: any[], fileName: string, headersArray: any[]): void {
  //   const header = headersArray;
  //   const data = jsonData;

  //   const workbook = new workbook();
  //   const worksheet = workbook.addWorksheet(fileName);
  //   data.forEach((element) => {
  //     const eachRow = [];
  //     headersArray.forEach((headers) => {
  //       eachRow.push(element[headers]);
  //     });
  //     if (element.isDeleted === 'Y') {
  //       const deletedRow = worksheet.addRow(eachRow);
  //       deletedRow.eachCell((cell) => {
  //         cell.font = { name: 'Calibri', family: 4, size: 11, bold: false, strike: true };
  //       })
  //     } else {
  //       worksheet.addRow(eachRow);
  //     }
  //   });


  //   const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(jsonData);
  //   const wb: XLSX.WorkBook = { Sheets: { 'data': ws }, SheetNames: ['data'] };
  //   const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
  //   this.saveExcelFile(excelBuffer, fileName);
  // }

}
